<script setup>
import { computed } from 'vue'
import { FORM_COLOR_MAP } from '../../../composables/useReservationsCalendar.js'

const props = defineProps({
    rank:    { type: Number, required: true },
    form:    { type: Object, required: true },
    // { id, name, color, count, revenue }
    maxCount:{ type: Number, default: 1 },
})

const hexColor = computed(() => FORM_COLOR_MAP[props.form.color] ?? '#6B7280')
const pct      = computed(() => Math.round((props.form.count / props.maxCount) * 100))
</script>

<template>
    <div class="flex items-center gap-2.5 py-2.5">
        <div class="w-[18px] text-[12px] font-bold text-gray-300 dark:text-neutral-600 text-center flex-shrink-0">{{ rank }}</div>
        <div class="w-2.5 h-2.5 rounded-[3px] flex-shrink-0" :style="{ background: hexColor }"/>
        <div class="flex-1 min-w-0">
            <div class="text-[13px] font-semibold text-gray-900 dark:text-white truncate">{{ form.name }}</div>
            <div class="h-1.5 rounded-full bg-gray-100 dark:bg-neutral-800 mt-1.5 overflow-hidden">
                <div class="h-full rounded-full" :style="{ width: pct + '%', background: hexColor }"/>
            </div>
        </div>
        <div class="text-right flex-shrink-0">
            <div class="text-[13px] font-bold text-gray-900 dark:text-white">{{ form.count }}</div>
            <div class="text-[10.5px] text-gray-400 dark:text-neutral-500">{{ form.revenue }}</div>
        </div>
    </div>
</template>
